import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';

const state = {
    id: 0,
    nombre: '',
    paisId: 0,
    pais: null,
    paisNombre: null,
    inactivo: false,
    rowVersion: null,
    
    bancoDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_BANCO'(state, bancoId) {
        state.id = bancoId;
        state.nombre = '';
        state.paisId = 0;
        state.pais = null;
        state.paisNombre = null;
        state.inactivo = false;
        state.rowVersion = null;
    },
    'SET_BANCO'(state, banco) {
        state.nombre = banco.nombre.toUpperCase().trim();
        state.paisId = banco.pais? banco.pais.id : 0;
        state.pais = banco.pais;
        state.paisNombre = banco.pais? banco.pais.nombre : null;
        state.inactivo = banco.inactivo;
        state.rowVersion = banco.rowVersion;
    },
    'SET_PAIS'(state, pais) {
        state.pais = pais;

        if (pais) {
            state.paisId = pais.id? pais.id : 0;
            state.paisNombre = pais.nombre? pais.nombre.trim() : null;
        } else {
            state.paisId = 0;
            state.paisNombre = null;
        }
    },

    'INICIALIZAR_DATOS'(state) {
        state.bancoDatos = [];
    },
    'SET_DATOS'(state, datos) {
        state.bancoDatos = datos;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, bancoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_BANCO', bancoId);

            if (bancoId != 0) {
                apiAxios.get('bancos/' + bancoId + '/abm' ) 
                .then(res => {
                    commit('SET_BANCO', res.data);
                    resolve();
                })
                .catch(error => reject(error))
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })
    },    
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let banco = {
                nombre: state.nombre.toUpperCase().trim(),
                paisId: state.paisId,
                inactivo: state.inactivo,
            }

            let url = 'bancos';
            if (state.id != 0) {
                url += '/' + state.id;
                banco.rowVersion = state.rowVersion;
            }
            
            apiAxios.post(url, banco)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    setPais: ({commit}, pais) => {
        commit('SET_PAIS', pais);
    },

    getDatos ( { commit }, bancoId ) {
        return new Promise((resolve, reject) => {

            commit('INICIALIZAR_DATOS');
            
            if (bancoId) {
                if (bancoId != 0) {
                    apiAxios.get('bancos/' + bancoId ) 
                    .then(res => {
                        var datos = [
                            { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                            { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                            { 'nombre': 'pais', 'campo': 'Pais', 'valor': res.data.pais, 'formato': '' },
                            { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': (res.data.inactivo) ? 'Si' : 'No', 'formato': '' },
                        ];
                        commit('SET_DATOS', datos);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
                }
            } 
        }, error => {
            reject(error);
        })            
    },
    inactivar ( {}, bancoId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('bancos/' + bancoId + '/inactivar')
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}